import type {
    NormalizedRTCStats,
    InboundVideoMetrics,
    OutboundVideoMetrics,
} from './statsCollector.types';

export const isVideoMetrics = (
    value: NormalizedRTCStats,
): value is InboundVideoMetrics | OutboundVideoMetrics =>
    'framesPerSecond' in value;
